export const isDocumentId = (value) =>
  typeof value === "string" && value.trim().length > 0 && !value.includes("/");

// Folder membership stays on each station document. No folder documents.
export const folderOf = (project) =>
  typeof project.folder === "string" && project.folder.trim() ? project.folder : null;

export const folderNames = (projects) =>
  [...new Set(projects.map(folderOf).filter(Boolean))].sort(
    (a, b) => a.localeCompare(b, undefined, { sensitivity: "base", numeric: true }) || a.localeCompare(b),
  );

export const listId = (folder) => folder === null ? "root" : `folder:${folder}`;
export const projectId = (project) => `project:${project.stationId}`;

export function overlayFolders(projects, changes) {
  return projects.map((project) =>
    Object.prototype.hasOwnProperty.call(changes, project.stationId)
      ? { ...project, folder: changes[project.stationId] }
      : project,
  );
}

// Read all projects before writing; don't overwrite a concurrent folder move.
export async function saveFolders(db, spaceId, projects, folder) {
  if (!isDocumentId(spaceId)) throw new Error("The workspace is not ready. Please reopen it and try again.");
  if (!projects.length) throw new Error("Select at least one project.");
  if (projects.some((project) => !isDocumentId(project.stationId))) {
    throw new Error("A project has no valid stationId. Reload the workspace before moving it.");
  }
  if (projects.length > 500) throw new Error("Please move at most 500 projects at a time.");
  const collection = db.collection("space").doc(spaceId).collection("stations");
  await db.runTransaction(async (transaction) => {
    const refs = projects.map((project) => collection.doc(project.stationId));
    const docs = await Promise.all(refs.map((ref) => transaction.get(ref)));
    docs.forEach((doc, index) => {
      if (!doc.exists || folderOf(doc.data()) !== folderOf(projects[index])) {
        throw new Error("A project changed. Close this dialog and try again with the latest list.");
      }
    });
    refs.forEach((ref) => transaction.update(ref, { folder }));
  });
}
